function optionalEnv(name: string) {
	return import.meta.env[name] as string | undefined;
}

function requiredEnv(name: string) {
	const value = import.meta.env[name];
	if (value === undefined || typeof value !== "string") {
		throw new Error(`Environment variable ${name} missing`);
	}
	return value;
}

function optionalEnvInt(name: string) {
	const rawValue = optionalEnv(name);
	if (rawValue === undefined || rawValue === "") {
		return undefined;
	}
	return parseInt(rawValue, 10);
}

export { optionalEnv, optionalEnvInt, requiredEnv };
